import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { ComponentSync, _className } from '@nu-art/thunderstorm-frontend/index';
import './ScrollBar.scss';
export class ScrollBar extends ComponentSync {
    observer;
    scrollRatio = 1;
    isScrolling = { scrollbar: false, scrollable: false };
    //######################### Life Cycle #########################
    __onScrollBarUpdate = (ref) => {
        if (ref !== this.state.scrollableRef)
            return;
        this.syncScrollbarContentHeight();
        this.disconnectScrollEvents();
        this.connectScrollEvents();
    };
    deriveStateFromProps(nextProps, state) {
        state.scrollableRef ??= nextProps.scrollableRef;
        state.scrollbarRef ??= React.createRef();
        return state;
    }
    componentDidMount() {
        const scrollable = this.state.scrollableRef.current;
        const scrollbar = this.state.scrollbarRef.current;
        if (!scrollable || !scrollbar) {
            this.logDebug('Will not connect things, missing one of the elements');
            return;
        }
        //Connect an observer to the scrollable to trigger height sync
        this.observer = new MutationObserver(() => this.syncScrollbarContentHeight());
        this.observer.observe(scrollable, {
            childList: true,
            subtree: true,
            characterData: true,
        });
        //Call the height sync at least once
        this.syncScrollbarContentHeight();
        //Set event listeners for scroll
        this.connectScrollEvents();
    }
    componentWillUnmount() {
        //Disconnect mutation observer
        if (this.observer)
            this.observer.disconnect();
        //Disconnect scroll listeners
        this.disconnectScrollEvents();
    }
    //######################### Logic #########################
    connectScrollEvents() {
        const scrollable = this.state.scrollableRef.current;
        const scrollbar = this.state.scrollbarRef.current;
        if (scrollable) {
            scrollable.addEventListener('scroll', this.scrollSyncScrollable);
            scrollable.addEventListener('scroll', this.checkScrollHeight);
        }
        if (scrollbar) {
            scrollbar.addEventListener('scroll', this.scrollSyncScrollbar);
            scrollbar.addEventListener('scroll', this.checkScrollHeight);
        }
    }
    disconnectScrollEvents() {
        if (this.state.scrollbarRef.current)
            this.state.scrollbarRef.current.removeEventListener('scroll', this.scrollSyncScrollbar);
        if (this.state.scrollableRef.current) {
            this.state.scrollableRef.current.removeEventListener('scroll', this.scrollSyncScrollable);
            this.state.scrollableRef.current.removeEventListener('scroll', this.checkScrollHeight);
        }
    }
    syncScrollbarContentHeight = () => {
        const scrollbar = this.state.scrollbarRef;
        const scrollContent = this.state.scrollableRef;
        if (!scrollbar.current || !scrollContent.current)
            return;
        //Collect height ratio of the scrollable
        const scrollContentHeight = scrollContent.current.getBoundingClientRect().height;
        const scrollbarHeight = scrollbar.current.getBoundingClientRect().height;
        const scrollContentScrollHeight = scrollContent.current.scrollHeight;
        this.scrollRatio = scrollContentScrollHeight / scrollContentHeight;
        //Set the height of the scrollbar content element based on the scrollbar height and the ratio
        const newHeight = Math.floor(scrollbarHeight * this.scrollRatio);
        scrollbar.current.children[0].style.height = `${newHeight}px`;
        this.setState({ canScroll: newHeight > Math.ceil(scrollbarHeight) });
    };
    //Called on scroll in the scrollable
    scrollSyncScrollable = () => {
        if (this.isScrolling.scrollable)
            return this.isScrolling.scrollable = false;
        const scrollbar = this.state.scrollbarRef.current;
        const scrollable = this.state.scrollableRef.current;
        if (!scrollable || !scrollbar)
            return;
        this.isScrolling.scrollbar = true;
        const scrollRatio = scrollbar.scrollHeight / scrollable.scrollHeight;
        scrollbar.scrollTop = scrollable.scrollTop * scrollRatio;
        this.isScrolling.scrollbar = false;
    };
    //Called on scroll in the scrollbar
    scrollSyncScrollbar = () => {
        if (this.isScrolling.scrollbar)
            return this.isScrolling.scrollbar = false;
        const scrollbar = this.state.scrollbarRef.current;
        const scrollable = this.state.scrollableRef.current;
        if (!scrollable || !scrollbar)
            return;
        this.isScrolling.scrollable = true;
        const scrollRatio = scrollable.scrollHeight / scrollbar.scrollHeight;
        scrollable.scrollTop = scrollbar.scrollTop * scrollRatio;
    };
    //Called on scroll in either element, checks if the scroll height needs fixing
    checkScrollHeight = () => {
        const scrollable = this.state.scrollableRef.current;
        if (!scrollable)
            return;
        const rect = scrollable.getBoundingClientRect();
        const ratio = scrollable.scrollHeight / rect.height;
        if (ratio !== this.scrollRatio)
            this.syncScrollbarContentHeight();
    };
    //######################### Render #########################
    render() {
        const className = _className('scroll-bar', !this.state.canScroll && 'hide');
        return _jsx("div", { className: className, ref: this.state.scrollbarRef, children: _jsx("div", { className: 'scroll-bar__content' }) });
    }
}
//# sourceMappingURL=ScrollBar.js.map